export default "__VITE_ASSET__16ba3b30__"